import { Check } from "lucide-react";
import { cn } from "@/lib/cn";
import { Stage } from "@/types/billing";

const STAGES: { id: Stage; label: string; short: string }[] = [
  { id: "collecting",  label: "Inkasowanie",  short: "Inkaso"  },
  { id: "invoicing",   label: "Fakturowanie", short: "Faktury" },
  { id: "notifying",   label: "Wysyłka",      short: "Wysyłka" },
  { id: "closed",      label: "Zamknięty",    short: "Zamkn."  },
];

const ORDER: Record<Stage, number> = {
  collecting: 0, invoicing: 1, notifying: 2, closed: 3,
};

interface Props { stage: Stage; }

export function StageRail({ stage }: Props) {
  const current = ORDER[stage];

  return (
    <div className="flex items-center gap-0">
      {STAGES.map((s, i) => {
        const idx = ORDER[s.id];
        const isPast    = idx < current;
        const isCurrent = idx === current;
        const isFuture  = idx > current;

        return (
          <div key={s.id} className="flex items-center">
            {/* Connecting line before this dot (except first) */}
            {i > 0 && (
              <div className={cn(
                "w-6 h-px transition-colors duration-300",
                isPast || isCurrent ? "bg-accent/40" : "bg-border",
              )} />
            )}

            {/* Step */}
            <div className="flex flex-col items-center gap-0.5">
              <div className={cn(
                "flex items-center justify-center rounded-full border transition-all duration-300",
                isCurrent && "w-5 h-5 bg-accent border-accent text-bg",
                isPast    && "w-4 h-4 bg-success/15 border-success/40 text-success",
                isFuture  && "w-4 h-4 bg-bg border-border text-text-subtle",
              )}>
                {isPast
                  ? <Check className="size-2.5 stroke-[3]" />
                  : <span className={cn("text-[9px] font-bold leading-none", isCurrent ? "text-bg" : "text-text-subtle")}>
                      {idx + 1}
                    </span>
                }
              </div>
              <span className={cn(
                "text-[10px] leading-none whitespace-nowrap transition-colors",
                isCurrent && "text-text font-semibold",
                isPast    && "text-text-muted",
                isFuture  && "text-text-subtle",
              )}>
                {isCurrent ? s.label : s.short}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
